import { keyframes } from 'styled-components';
export const HeadShakeAnimation = keyframes `
  0% {
    transform: translateX(0);
  }

  6.5% {
    transform: translateX(-3px) rotateY(-4.5deg);
  }

  18.5% {
    transform: translateX(2.5px) rotateY(3.5deg);
  }

  31.5% {
    transform: translateX(-1.5px) rotateY(-2.5deg);
  }

  43.5% {
    transform: translateX(1px) rotateY(1.5deg);
  }

  50% {
    transform: translateX(0);
  }
`;
